import React, { FC } from 'react'

import { SelectAssignUsersInput } from 'src/components/molecules'

import { useGetExternalUsers } from 'src/hooks'
import { ExternalUserEntity, UserEntity } from 'src/types'

type Props = {
  excludedExternalUsers?: ExternalUserEntity[]
  onSelectExternalUser: (user: ExternalUserEntity) => void
  onBatchSelect?: (users: ExternalUserEntity[]) => void
  rounded?: boolean
  className?: string
}

export const SelectExternalUsersInput: FC<Props> = ({
  excludedExternalUsers = [],
  onSelectExternalUser,
  onBatchSelect,
  rounded,
  className,
}) => {
  const { loading, externalUsers } = useGetExternalUsers()

  const handleOnSelectUser = (selectedUser: UserEntity) => {
    const selectedExternalUser = externalUsers.find(
      externalUser => selectedUser.id === externalUser.id
    )
    selectedExternalUser && onSelectExternalUser(selectedExternalUser)
  }

  const handleOnBatchSelect = (selectedUsers: UserEntity[]) => {
    const selectedExternalUsers = externalUsers.filter(externalUser =>
      selectedUsers.some(selectedUser => selectedUser.id === externalUser.id)
    )
    onBatchSelect?.(selectedExternalUsers)
  }

  return (
    <div className={className}>
      {!loading && externalUsers && (
        <SelectAssignUsersInput
          targetUsers={externalUsers}
          onSelectUser={handleOnSelectUser}
          onBatchSelect={handleOnBatchSelect}
          excludedUsers={excludedExternalUsers}
          rounded={rounded}
        />
      )}
    </div>
  )
}
